import { render, staticRenderFns } from "./comp_Hook-ShopApp-SmartPopup.vue?vue&type=template&id=05cefc5b&scoped=true&"
import script from "./comp_Hook-ShopApp-SmartPopup.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-ShopApp-SmartPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cefc5b",
  null
  
)

export default component.exports